import { Flex, FlexSmAlignCenter } from 'components/Elements';
import Spinner from 'components/Spinner';
import React from 'react';
import { ButtonProps, StyledButton } from './ButtonStyle';
import BinIcon from 'assets/icons/controls/BinIcon';

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
    (
        {
            title,
            aria,
            type = 'button',
            onClick,
            icon,
            disabled,
            fullwidth,
            colour = 'SECONDARY',
            submitting,
            iconOnRight,
            unfocus, //hidden from both keyboard and screen readers
            ...props
        },
        ref,
    ) => {
        const handleClick = async (e: React.MouseEvent<HTMLButtonElement>) => {
            if (!onClick) return;

            const result = onClick(e);

            if (result instanceof Promise) {
                await result;
            }
        };

        const finalIcon = submitting ? <Spinner /> : colour === 'BLACK' ? <BinIcon /> : icon;

        return (
            <StyledButton
                ref={ref}
                type={type}
                disabled={disabled || submitting}
                $fullwidth={fullwidth}
                aria-label={aria}
                onClick={handleClick}
                $colourType={type === 'submit' ? 'PRIMARY' : colour}
                tabIndex={unfocus ? -1 : 0}
                aria-hidden={unfocus}
                {...props}
            >
                {iconOnRight ? (
                    <FlexSmAlignCenter>
                        {title}
                        {finalIcon && <Flex>{finalIcon}</Flex>}
                    </FlexSmAlignCenter>
                ) : (
                    <FlexSmAlignCenter>
                        {finalIcon && <Flex>{finalIcon}</Flex>}
                        {title}
                    </FlexSmAlignCenter>
                )}
            </StyledButton>
        );
    },
);

export default Button;
